export const schemaVariables = {
  inputWidthClass: 'col-11 col-sm-10 col-md-10 col-lg-7',
  selectWidthClass: 'col-11 col-sm-10 col-md-8 col-lg-5',
  selectWideWidthClass: 'col-11 col-sm-10 col-md-10 col-lg-7',
  selectInlineWidthClass: 'col-11 col-sm-4 col-md-4 col-lg-3',
  inputInlineWidthClass: 'col-11 col-sm-6 col-md-6 col-lg-4',
  checkboxWidthClass: 'col-11 col-sm-6 col-md-5 col-lg-4',
  autcompleteValue: 'onb-no-complete-2021',
};
